var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0.666992L13.9779 1.88431C14.283 1.9521 14.5 2.22264 14.5 2.53511V9.19293C14.5 10.5303 13.8316 11.7793 12.7188 12.5211L8.5 15.3337L4.2812 12.5211C3.16841 11.7793 2.5 10.5303 2.5 9.19293V2.53511C2.5 2.22264 2.71702 1.9521 3.02205 1.88431L8.5 0.666992ZM8.5 2.03285L3.83333 3.06989V9.19293C3.83333 10.0845 4.27893 10.9171 5.0208 11.4117L8.5 13.7312L11.9792 11.4117C12.7211 10.9171 13.1667 10.0845 13.1667 9.19293V3.06989L8.5 2.03285ZM11.4683 5.48155L12.4111 6.42435L8.1684 10.667L5.33999 7.83859L6.28281 6.89573L8.16793 8.78093L11.4683 5.48155Z",
    fill: "#2A8E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/Secure.fae2b49a324cada62ebd70e303db5aa6.svg";
export { ForwardRef as ReactComponent };